import './App.scss';
import {CSSTransition} from 'react-transition-group';
import {useState} from 'react';
import FixedButtonGroup from './components/FixedButtonGroup/FixedButtonGroup';
import LoadingPage from './components/LoadingPage/LoadingPage';
import CanvasEntrace from './components/CanvasEntrace/CanvasEntrace';

const App = () => {
    const [loaderStatus, setLoaderStatus] = useState<boolean>(true);

    // canvas 場景是否開啟, true直接進場
    const [canvasStatus, setCanvasStatus] = useState<boolean>(true);

    // 判斷是否在首頁，hallwayToLoby 有值就代表在canvas頁面
    // hallwayToLoby會放函示，執行 hallwayToLoby
    const [hallwayToLoby, setHallwayToLoby] = useState<any>(null);

    // 給 內部組件，放置長廊的位置，3個X軸的位置 0, 0.1, 0.5
    const [hallwayPositionX, setHallwayPositionX] = useState<number>(0);

    return (
        <div className="app" style={{position: 'fixed', width: '100vw', height: '100vh'}}>
            <CSSTransition
                in={loaderStatus}
                timeout={300}
                classNames="fade-video">
                <div className="loading-container">
                    {loaderStatus && (
                        <LoadingPage
                            setLoaderStatus={setLoaderStatus}
                        />
                    )}
                </div>
            </CSSTransition>

            {canvasStatus && (
                <CanvasEntrace
                    hallwayPositionX={hallwayPositionX}
                    setHallwayToLoby={setHallwayToLoby}
                />
            )}

            <FixedButtonGroup
                canvasStatus={canvasStatus && !loaderStatus}
                setCanvasStatus={setCanvasStatus}
                hallwayToLoby={hallwayToLoby}
                setHallwayToLoby={setHallwayToLoby}
            />
        </div>
    );
};

export default App;
